import {Alert, Platform} from 'react-native';
import i18n from '../../i18n';

let activeDialogHandler = null;

export const registerCashRegisterRetryDialogHandler = (handler) => {
    activeDialogHandler = handler;

    return () => {
        if (activeDialogHandler === handler) {
            activeDialogHandler = null;
        }
    };
};

export const showCashRegisterRetryDialog = (options = {}) => {
    if (typeof activeDialogHandler === 'function') {
        return activeDialogHandler(options);
    }

    const {
        orderCode,
        attemptRetry,
        initialError,
    } = options;

    return new Promise((resolve) => {
        const message = i18n.t('cash_register_timeout_message', {
            orderCode,
            errorMessage: initialError?.message,
        });

        if (Platform.OS === 'android') {
            Alert.alert(
                i18n.t('cash_register_timeout_title'),
                message,
                [
                    {
                        text: i18n.t('cash_register_retry_receipt'),
                        onPress: async () => {
                            try {
                                await attemptRetry?.();
                                resolve(true);
                            } catch (_retryError) {
                                Alert.alert(
                                    i18n.t('cash_register_unresponsive_title'),
                                    i18n.t('cash_register_unresponsive_message')
                                );
                                resolve(false);
                            }
                        },
                    },
                ],
                {cancelable: false}
            );
            return;
        }

        resolve(false);
    });
};
